import React from 'react';

import { CONFIG_ITEM_KEYS } from '../../../config-items/config-item-keys';
import type {
	EditorPluginAIConfigItemWithOptions,
	EditorPluginAIConfigItem,
} from '../../../config-items/config-items';
import { createEditorPluginAIConfigItemMarkdown } from '../../../config-items/config-items';
import { Icon } from '../../assets/icons/makeLonger';
import { createInsertBelow, createReplace } from '../../config-item-actions/markdown';
import { isMinLength } from '../../config-item-visible/visibility-utils';

import { messages } from './messages';

const intentSchemaId = 'make_longer.json';

// TODO swap to @atlaskit/icon once available
const IconMakeLonger = () => {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M5 5.75L19 5.75M5 9.91667L19 9.91667M5 14.0833L19 14.0833M5 18.25L12 18.25"
				stroke="#44546F"
				strokeWidth="1.5"
			/>
		</svg>
	);
};

export const makeLonger: EditorPluginAIConfigItem = {
	key: CONFIG_ITEM_KEYS.MAKE_LONGER,
	title: messages.title,
	description: messages.description,
	icon: ({ shownAt }) => <Icon shownAt={shownAt} />,
	statusLozengeType: 'beta',
	intentSchemaId,
	getBackendModel: () => 'assistance-service',
	showInRefineDropdown: true,
	actions: {
		empty: [
			createInsertBelow({ appearance: 'secondary' }),
			createReplace({ appearance: 'primary' }),
		],
		selection: [
			createInsertBelow({ appearance: 'secondary' }),
			createReplace({ appearance: 'primary' }),
		],
	},
};

export const makeLongerWithOptions: EditorPluginAIConfigItemWithOptions = {
	config: makeLonger,
	triggers: { empty: { docMinSize: 1 }, selection: true },
};

// remove this when cleanup platform_editor_ai_remove_selection_type
export const makeLongerEmptyConfigItem = createEditorPluginAIConfigItemMarkdown<'empty'>({
	key: CONFIG_ITEM_KEYS.MAKE_LONGER,
	title: messages.title,
	description: messages.description,
	icon: ({ shownAt }) => <IconMakeLonger />,
	statusLozengeType: 'beta',
	selectionType: 'empty',
	intentSchemaId,
	isVisible: ({ editorView, positions }) => isMinLength({ editorView, minLength: 1, positions }),
	getBackendModel: () => 'assistance-service',
	actions: [
		createInsertBelow({ appearance: 'secondary' }),
		createReplace({ appearance: 'primary' }),
	],
});

// remove this when cleanup platform_editor_ai_remove_selection_type
export const makeLongerRangeConfigItem = createEditorPluginAIConfigItemMarkdown<'range'>({
	key: CONFIG_ITEM_KEYS.MAKE_LONGER,
	title: messages.title,
	description: messages.description,
	icon: ({ shownAt }) => <IconMakeLonger />,
	statusLozengeType: 'beta',
	selectionType: 'range',
	intentSchemaId,
	isVisible: ({ editorView, positions }) => isMinLength({ editorView, minLength: 1, positions }),
	getBackendModel: () => 'assistance-service',
	showInRefineDropdown: true,
	actions: [
		createInsertBelow({ appearance: 'secondary' }),
		createReplace({ appearance: 'primary' }),
	],
});
